import { render, staticRenderFns } from "./replenishment.vue?vue&type=template&id=c38f494c&scoped=true"
import script from "./replenishment.vue?vue&type=script&lang=js"
export * from "./replenishment.vue?vue&type=script&lang=js"
import style0 from "./replenishment.vue?vue&type=style&index=0&id=c38f494c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38f494c",
  null
  
)

export default component.exports